<template>
  <div class="container_box">
    <Tabs v-model="pageParams.orderStatusTab" :animated="false" class="tabs_styles" @on-click="changeTab">
      <TabPane v-for="item in orderTabTypeList" :label="item.title" :name="item.value"></TabPane>
    </Tabs>
    <!--头部筛选区域-->
    <div class="filter_box">
      <Form ref="pageParams" :model="pageParams" :label-width="labelWidth" @submit.native.prevent>
        <Row type="flex" :gutter="gutterItem">
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <dropDownFilter
              :transfer="false"
              ref="dropDownFilter_1"
              inputType="textarea"
              :selectStyle="{width: '110px'}"
              :dropDownInputList="dropDownInputList_1"
              :defaultSelectValue="defaultSelectValue_1"
              @changeInput="(val)=>changeInput(val,'_1')"
              @updateInputValue="updateInputValue">
            </dropDownFilter>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <dropDownFilter
              :transfer="false"
              ref="dropDownFilter_2"
              inputType="textarea"
              :selectStyle="{width: '95px'}"
              :dropDownInputList="dropDownInputList_2"
              :defaultSelectValue="defaultSelectValue_2"
              @changeInput="(val)=> changeInput(val,'_2')"
              @updateInputValue="updateInputValue">
            </dropDownFilter>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol"
            v-if="['0', '1'].includes(pageParams.orderStatusTab)">
            <FormItem :label="$t('key1004602')" prop="orderStatusList">
              <Select v-model="pageParams.orderStatusList" multiple :placeholder="$t('key1004603')">
                <Option v-for="item in orderStatusList" :key="item.value" :value="item.value">{{ item.title }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol"
            v-if="['0', '1', '2', '3', '4'].includes(pageParams.orderStatusTab)">
            <FormItem :label="$t('key1004555')" prop="outPackageStatusList">
              <Select v-model="pageParams.outPackageStatusList" multiple :placeholder="$t('key1004569')">
                <Option v-for="item in deliveryOrderStatusList" :key="item.value" :value="item.value">{{ item.title }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <dropDownDateTime
              :transfer="false"
              :formatType="formatType"
              ref="dropDownDateTime"
              :dropDownTimeList="dropDownTimeList"
              :defaultSelectValue="defaultSelectTimeValue"
              @changeInput="changeTimeInput"
              @selectTime="selectTime"
              @resetTime="resetTime">
            </dropDownDateTime>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol"
            v-if="['0', '3'].includes(pageParams.orderStatusTab)">
            <FormItem :label="$t('key1004604')" prop="settlementStatus">
              <Select v-model="pageParams.settlementStatus" multiple :placeholder="$t('key1004605')">
                <Option v-for="item in settlementStatusList" :key="item.value" :value="item.value">{{ item.title }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1004606')" prop="timeout">
              <div class="flex align-items-center">
                <InputNumber :min="0" v-model="pageParams.timeoutStart" :formatter="value => `${parseInt(value)}`" style="width: 87px;"></InputNumber>
                <span class="ml5">{{ $t('key1001632') }}</span>
                <span class="ml12 mr12">-</span>
                <InputNumber v-model="pageParams.timeoutEnd" :formatter="value => `${parseInt(value)}`" style="width: 87px;"></InputNumber>
                <span class="ml5">{{ $t('key1001632') }}</span>
              </div>
            </FormItem>
          </Col>
          <Col style="min-width: 200px;" push="1">
            <Button @click="reset" icon="md-refresh" class="mr12">{{ $t('key1000109') }}</Button>
            <Button type="primary" @click="search" icon="md-search">{{ $t('key1000361') }}</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <!--功能按钮操作区域-->
    <div class="operation_box flex align-items-center justify-content-between">
      <div class="flex align-items-center">
        <!--导出订单-->
        <Dropdown transfer @on-click="changeExportBtn" class="mr15"
          v-if="getPermission('ymsSubPackageInfo_exportSupplierPackageInfoOrder')">
          <Button type="primary">
            <span>{{ $t('key1004572') }}</span>
            <Icon type="ios-arrow-down"></Icon>
          </Button>
          <DropdownMenu slot="list">
            <DropdownItem name="1">{{ $t('key1003083') }}</DropdownItem>
            <DropdownItem name="2">{{ $t('key1003084') }}</DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </div>
      <!--自定义列-->
      <Button @click="$refs['customColumns'].initCustomColumnsData()">{{ $t('key1000977') }}</Button>
    </div>
    <!--列表区域-->
    <div class="table_box">
      <Table
        ref="tableDom"
        highlight-row
        :loading="tableLoading"
        border
        max-height="530"
        :columns="tableColumns"
        :data="tableData"
        :span-method="handleSpan"
        @on-selection-change="tableChange">
      </Table>
      <Page
        :transfer="true"
        v-if="!tableLoading"
        :total="total"
        @on-change="changePage"
        show-total
        :page-size="pageParams.pageSize"
        show-elevator
        :current="pageParams.pageNum"
        show-sizer
        @on-page-size-change="changePageSize"
        placement="top"
        :page-size-opts="pageArray">
      </Page>
    </div>
    <!--导出数据字段弹窗-->
    <exportFieldsModal
      ref="exportFields"
      :exportFieldsTitle="$t('key1004572')"
      paramKeyColums="supplierPackageInfoExportColumns"
      :customFieldExportList="customFieldExportList"
      @exportFieldsDataBtn="exportFieldsDataBtn">
    </exportFieldsModal>
    <!--自定义列组件-->
    <customColumnsDrawer
      ref="customColumns"
      customColumnsKey="supplierOrdersColumns"
      :originalColumns="originalColumns"
      :defaultSelectKeyList="defaultSelectKeyList"
      @customColumnsData="customColumnsData">
    </customColumnsDrawer>
    <!--超时订单处理弹窗-->
    <overtimeOrderProcessingModal
      ref="overtimeOrderProcess"
      @updateData="pageParamsStatus = true">
    </overtimeOrderProcessingModal>
    <!--日志弹窗-->
    <supplierOrdersLogModal ref="supplierOrdersLog"></supplierOrdersLogModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from "@/components/mixin/common_mixin";
import exportFieldsModal from "@/components/common/exportFieldsModal.vue";
import dropDownFilter from "@/components/common/dropDownFilter.vue";
import dropDownDateTime from "@/components/common/dropDownDateTime";
import overtimeOrderProcessingModal from "@/components/common/overtimeOrderProcessingModal";
import customColumnsDrawer from "@/components/common/customColumnsDrawer";
import supplierOrdersLogModal from "@/views/yms/components/orderList/supplierOrdersLogModal";
import {isValueEmpty, pageJump, amountHandel, setConfigCharacters, getDataSetBatchList, getEnumList, getEnumName} from "@/utils/common";

export default {
  name: "supplierOrders",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      total: 0,
      pageParamsStatus: false,
      pageParams: {
        orderStatusTab: '1', // 0:全部 1:待发货 2:已发货 3:已完成 4:已取消
        createdEndTime: null, // 下单结束时间
        createdStartTime: null, // 下单开始时间
        shipedStartTime: null, // 发货开始时间
        shipedEndTime: null, // 发货结束时间
        estimateArrivalOfGoodsStartTime: null, // 预计到货的开始时间
        estimateArrivalOfGoodsEndTime: null, // 预计到货的结束时间
        outPackageStatusList: [], // 出库单状态
        packageCodes: '', // 订单号
        orderStatusList: [], // 订单状态
        skus: '', // 供应商sku
        ymsSkus: '', // 云卖sku
        orderShippingIds: '',
        settlementStatus: [], // 结算状态
        ymsSupplierMerchantIds: '', // 供应商编号
        supplierNames: '', // 供应商名称
        timeoutStart: null,
        timeoutEnd: null,
        pageNum: 1,
        pageSize: 15,
      },
      tableData: [],
      tableColumns: [],
      originalColumns: [
        {
          type: 'selection',
          width: 60,
          fixed: 'left',
          key: 'idx',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004432'),
          key: 'subPackageCode',
          className: 'set_table_td',
          align: 'left',
          minWidth: 220,
          render(h, params) {
            let orderShippingId = params.row.orderShippingId;
            let subPackageCode = params.row.subPackageCode;
            return h('div', [
              h('p', `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004573')}`),
              h('p', {class: 'mb8'}, orderShippingId),
              h('p', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004579')),
              h('p', subPackageCode)
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001098'),
          key: 'supplierMerchantId',
          minWidth: 140,
          className: 'set_table_td',
          align: 'left'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001101'),
          key: 'supplierName',
          className: 'set_table_td',
          minWidth: 140,
          align: 'left'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004580'),
          key: 'remainingShippingTime',
          className: 'set_table_td',
          minWidth: 170,
          align: 'left',
          render: (h, {row}) => {
            let timeoutLeftTime = row.timeoutLeftTime;
            if (timeoutLeftTime) {
              let time = v.$uDate.dealTime(timeoutLeftTime, 'fulltime');
              return h('span', v.handleTimeOut(time, row.orderStatus));
            } else {
              return h('span', '-');
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002917'),
          key: 'orderStatus',
          align: 'left',
          className: 'set_table_td',
          minWidth: 150,
          render(h, params) {
            let text = '-';
            let content = '';
            // 订单状态 1待发货 2已发货 3待重发 4已完成 5已取消 6超时未发 7缺货中
            let orderStatus = params.row.orderStatus;
            let waitingAgainSendJson = params.row.waitingAgainSendJson;
            v.orderStatusData.map((item) => {
              if (item.value === orderStatus) {
                text = item.title;
              }
            });
            // 缺货
            if (orderStatus === 7) {
              let abnormalStatus = params.row.abnormalStatus; // 异常状态 1.正常 2.缺货
              if (abnormalStatus === 2) {
                let outOfStockQuantity = params.row.outOfStockQuantity;
                let outOfStockText = `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004360')}${outOfStockQuantity}`;
                let estimateArrivalOfGoodsTime = v.$uDate.dealTime(params.row.estimateArrivalOfGoodsTime);
                let goodsStatus = params.row.goodsStatus; //货品状态 1.正常 2.停售
                return h('div', [
                  h('p', {class: 'redColor mt5 mb5'}, text),
                  h('p', {class: 'redColor mt5 mb5'}, outOfStockText),
                  goodsStatus === 1 ? h('div', [
                    h('p', {class: 'redColor'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004361')),
                    h('div', {class: 'flex align-items-center mt5 mb5'}, [
                      h('span', {class: 'redColor'}, estimateArrivalOfGoodsTime),
                      v.getPermission('ymsSubPackageInfo_markOutStock') ? h('Icon', {
                        props: {type: 'md-create', color: '#ff3300'},
                        style: {
                          marginLeft: '5px',
                          fontSize: '17px',
                          cursor: 'pointer',
                          position: 'relative',
                          top: '-2px'
                        },
                        on: {
                          click: () => {
                            v.markOutStockBtn(params.row.ymsSubPackageId, 2);
                          }
                        }
                      }) : ''
                    ])
                  ]) : '',
                  goodsStatus === 2 ? h('p', {class: 'redColor mt5 mb5'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000084')) : ''
                ]);
              }
            }
            // 待重发
            else if (orderStatus === 3) {
              if (waitingAgainSendJson) {
                let obj = JSON.parse(waitingAgainSendJson);
                let items = {
                  '1': `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004173')}${obj.pickupOrderNumber}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004574')}`,
                  '2': `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004173')}${obj.pickupOrderNumber} ${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004575')}`,
                };
                content = items[obj.type];
              }
              return h('div', {class: 'flex align-items-center'}, [
                h('span', {class: 'redColor'}, text),
                content ? h('Tooltip', {
                  props: {
                    transfer: true,
                    maxWidth: 250,
                    placement: 'top',
                    content: content
                  },
                  style: {
                    marginLeft: '5px'
                  }
                },
                [
                  h('Icon', {
                    props: {
                      type: 'md-help-circle',
                      size: 17
                    },
                    style: {
                      cursor: 'pointer',
                      color: '#ff3300'
                    }
                  })
                ]) : ''
              ]);
            } else {
              return h('div', {
                class: orderStatus === 6 ? 'redColor' : ''
              }, text);
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003884'),
          key: 'settlementStatus',
          align: 'left',
          className: 'set_table_td',
          minWidth: 140,
          render(h, params) {
            let text = '-';
            // 结算状态 1.未入账 2.结算中 3.已结算
            let settlementStatus = params.row.settlementStatus;
            v.settlementStatusList.map((item) => {
              if (item.value === settlementStatus) {
                text = item.title;
              }
            });
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001571'),
          key: 'logisticsInfo',
          minWidth: 240,
          className: 'set_table_td',
          align: 'left',
          render(h, params) {
            let shippingMethodText = '-';
            let logisticsProviderName = '-';
            let trackingNumberText = '-';
            let carrierName = params.row.carrierName || '-';
            // 发货方式
            let deliveryType = params.row.deliveryType; // 发货方式{1YMS物流 2自有物流}
            let transportType = params.row.transportType; // 运输方式{1快递 2上门揽收}
            if (deliveryType === 1) {
              let name = getEnumName(v.enumData, 'TransportTypeEnum', transportType, 'number');
              shippingMethodText = `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001581')}` + ' ' + '-' + ' ' + name;
            } else if (deliveryType === 2) {
              shippingMethodText = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001587');
            }
            // 物流商、物流单号
            let trackingNumber = params.row.trackingNumber || '-';
            let expressageNo = params.row.expressageNo || '-';
            if (deliveryType === 1 && transportType === 2) {
              trackingNumberText = `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001582')}`;
              logisticsProviderName = `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001582')}`;
            } else {
              trackingNumberText = deliveryType === 2 ? expressageNo : trackingNumber;
              if (transportType === 1 && deliveryType === 1) {
                logisticsProviderName = carrierName;
              } else {
                if (v.useLogisticsList.length > 0) {
                  v.useLogisticsList.map((item) => {
                    if (item.carrierId === carrierName) {
                      logisticsProviderName = item.carrierName;
                    }
                  });
                }
              }
            }
            return h('div', [
              h('p', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001575') + shippingMethodText),
              h('p', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001579') + logisticsProviderName),
              h('p', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001580') + trackingNumberText),
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004581'),
          key: 'timeout',
          minWidth: 150,
          className: 'set_table_td',
          align: 'left',
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000383'),
          key: 'commodityInfo',
          align: 'left',
          minWidth: 350,
          render(h, params) {
            if (params.row._productInfo) {
              let ymsSku = params.row._productInfo.ymsSku;
              let supplierSku = params.row._productInfo.supplierSku;
              let skuImgPath = params.row._productInfo.primaryImage;
              let spuImgPath = params.row._productInfo._spuInfo.primaryImage;
              let imgPath = skuImgPath ? skuImgPath : spuImgPath;
              let productGoodsSpecifications = params.row._productInfo.productGoodsSpecificationList || [];
              let spec = productGoodsSpecifications.map(i => i.value).join('、');
              return h('div', {class: 'flex'},
                [
                  v.tableImg(h, params, null, imgPath),
                  h('div', {
                    class: 'text-align-left pl10'
                  }, [
                    h('Alink', {
                      props: {
                        linkName: params.row._productInfo._spuInfo.name,
                        textAlign: 'left',
                        className: 'mb5',
                        AlinkClass: 'ellipsis_1'
                      },
                      on: {
                        AlinkBtn: () => {
                          const {href} = v.$router.resolve({
                            path: '/productDetails',
                            query: {
                              type: 'look',
                              productId: params.row._productInfo._spuInfo.ymsProductId,
                              supplierMerchantId: params.row._productInfo._spuInfo.supplierMerchantId
                            }
                          });
                          window.open(href, '_blank');
                        }
                      }
                    }),
                    h('div', {class: 'flex align-items-start mb5'}, [
                      h('p', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004582')),
                      h('p', {style: {flex: 1}, class: 'font-weight-bold'}, ymsSku),
                    ]),
                    h('div', {class: 'flex align-items-start mb5'}, [
                      h('p', 'SKU：'),
                      h('p', {style: {flex: 1}}, supplierSku),
                    ]),
                    h('div', {class: 'flex align-items-start mb5'}, [
                      h('p', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000240')),
                      h('p', {style: {flex: 1}, class: 'color-green'}, spec)
                    ]),
                  ])
                ]);
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003803'),
          key: 'quantity',
          align: 'left',
          className: 'set_table_td',
          minWidth: 140,
          render(h, params) {
            let orderStatus = params.row.orderStatus; // 订单状态 1待发货 2已发货 3待重发 4已完成 5已取消 6超时未发 7缺货中
            let quantity = params.row.quantity;
            let actualSortingNumber = [1, 2].includes(orderStatus) ? '-' : params.row.actualSortingNumber;
            let orderStatusTab = v.pageParams.orderStatusTab;
            return h('div', {class: 'flex flex-direction'}, [
              h('p', {class: 'mt2 mb1'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004355') + quantity),
              ['0', '3', '4'].includes(orderStatusTab) ? h('p', {class: 'mt2 mb1'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004583') + actualSortingNumber) : '',
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003599'),
          key: 'totalOrderPrice',
          className: 'set_table_td',
          align: 'left',
          minWidth: 140,
          renderHeader: (h, params) => {
            return h('p', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003599') + (v.currencyState ? '(' + v.currencyState + ')' : ''));
          },
          render(h, params) {
            let totalPriceCurrency = v.currencyState || '';
            let totalOrderPrice = amountHandel(params.row.totalOrderPrice);
            let text = '-';
            if (totalOrderPrice) {
              text = totalOrderPrice + ' ' + totalPriceCurrency;
            }
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004371'),
          key: 'packageStatus',
          align: 'left',
          className: 'set_table_td',
          minWidth: 130,
          render(h, params) {
            let text = '-';
            let outPackageStatus = params.row.outPackageStatus;
            v.deliveryOrderStatusList.map((item) => {
              if (item.value === outPackageStatus) {
                text = item.title;
              }
            });
            return h('span', {
              style: {
                color: outPackageStatus === 6 ? '#FF0000' : ''
              }
            }, text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004474'),
          key: 'createdTime',
          className: 'set_table_td',
          align: 'left',
          minWidth: 170,
          render(h, params) {
            return h('span', params.row.createdTime ? v.$uDate.dealTime(params.row.createdTime, 'fulltime') : '-');
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004584'),
          key: 'timeoutLeftTime',
          className: 'set_table_td',
          minWidth: 170,
          align: 'left',
          render(h, params) {
            return h('span', params.row.timeoutLeftTime ? v.$uDate.dealTime(params.row.timeoutLeftTime, 'fulltime') : '-');
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004565'),
          key: 'despatchTime',
          className: 'set_table_td',
          align: 'left',
          minWidth: 170,
          render(h, params) {
            return h('span', params.row.despatchTime ? v.$uDate.dealTime(params.row.despatchTime, 'fulltime') : '-');
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004585'),
          key: 'ymsOutTime',
          align: 'left',
          className: 'set_table_td',
          minWidth: 170,
          renderHeader(h, params) {
            return h('div', {class: 'flex align-items-center'}, [
              h('span', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004585')),
              h('Tooltip', {
                props: {
                  offset: 13,
                  transfer: true,
                  maxWidth: 300,
                  content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004586'),
                  placement: 'top-end'
                }
              }, [
                h('Icon', {
                  props: {
                    type: 'md-help-circle',
                    size: 17
                  },
                  class: 'cursor ml5 themeColor'
                })
              ])
            ]);
          },
          render(h, params) {
            return h('span', params.row.ymsOutTime ? v.$uDate.dealTime(params.row.ymsOutTime, 'fulltime') : '-');
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004462'),
          key: 'cancelledTime',
          className: 'set_table_td',
          align: 'left',
          minWidth: 170,
          render(h, params) {
            if (['0', '4'].includes(v.pageParams.orderStatusTab)) {
              return h('span', params.row.cancelledTime ? v.$uDate.dealTime(params.row.cancelledTime, 'fulltime') : '-');
            } else {
              return h('span', '-');
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          width: 210,
          key: 'options',
          fixed: 'right',
          align: 'left',
          className: 'set_table_td',
          render(h, params) {
            let orderStatus = params.row.orderStatus;
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004587'),
                    show: orderStatus === 7 && v.getPermission('ymsSubPackageInfo_markOutStock'), // 缺货中
                    clickFn: () => {
                      v.markArrivalBtn(params.row);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000526'),
                    color: '#FF0000',
                    show: [1, 3, 6].includes(orderStatus) && v.getPermission('ymsSubPackageInfo_markOutStock'),  // 待发货、待重发、超时未发
                    clickFn: () => {
                      v.markOutStockBtn(params.row.ymsSubPackageId, 1);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004588'),
                    show: orderStatus === 7 && v.getPermission('ymsSubPackageInfo_markOutStock'),
                    clickFn: () => {
                      v.markOutStockBtn(params.row.ymsSubPackageId, 2);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002478'),
                    show: true,
                    clickFn: () => {
                      v.$refs['supplierOrdersLog'].initsupplierOrdersLogData(params.row);
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      selectTableData: [],
      orderStatusList: [],
      deliveryOrderStatusList: [],
      orderTabTypeList: [
        {value: '0', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110')},
        {
          value: '1',
          title: (h) => {
            return h('div', [
              h('span', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002920')),
              h('Badge', {
                props: {
                  count: v.reviewedTotal,
                  overflowCount: 999
                }
              })
            ]);
          }
        },
        {value: '2', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004327')},
        {value: '3', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003563')},
        {value: '4', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001813')},
      ],
      dropDownInputList_1: [
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004589'), value: 1, placeholder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004590'), parameterKey: 'packageCodes'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000586'), value: 2, placeholder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004591'), parameterKey: 'skus'},
        {title: `${setConfigCharacters(false)}SKU`, value: 3, placeholder: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000324')}${setConfigCharacters(false)}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004499')}`, parameterKey: 'ymsSkus'},
        {title: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004576')}`, value: 4, placeholder: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000324')}${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004577')}`, parameterKey: 'orderShippingIds'}
      ],
      dropDownInputList_2: [
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002805'), value: 1, placeholder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002806'), parameterKey: 'ymsSupplierMerchantIds'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001101'), value: 2, placeholder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004592'), parameterKey: 'supplierNames'},
      ],
      defaultSelectValue_1: 1,
      defaultSelectValue_2: 1,
      exportType: '1',
      customFieldExportList: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000929'),
          titleKey: 'basicInfoColums',
          selectList: [], // 选中导出字段的key
          checkBoxList: [
            {paramKey: 'packageCode', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004589')},
            {paramKey: 'supplierMerchantId', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004593')},
            {paramKey: 'orderStatusStr', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002917')},
            {paramKey: 'name', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000380')},
            {paramKey: 'ymsSKU', paramValue: `${setConfigCharacters(false)}SKU`},
            {paramKey: 'quantity', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003656')},
            {paramKey: 'variations', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000721')},
            {paramKey: 'outPackageStatusStr', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004371')},
            {paramKey: 'totalPriceStr', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004594')},
            {paramKey: 'createdTime', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004474')},
            {paramKey: 'cancelledTime', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004462')},
            {paramKey: 'shipedTime', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004565')},
            {paramKey: 'ymsOutTime', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004585')},
            {paramKey: 'settlementStatusStr', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003884')},
            {paramKey: 'supplierSPU', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001093')},
            {paramKey: 'supplierSKU', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000586')},
            {paramKey: 'supplyPrice', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000882')},
            {paramKey: 'createdPackageCostTime', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003817')},
            {paramKey: 'labelType', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003818')},
            {paramKey: 'subPackageType', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004595')},
            {paramKey: 'orderShippingId', paramValue: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004576')}`},
            {paramKey: 'deliveryType', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003867')},
            {paramKey: 'carrierName', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000220')},
            {paramKey: 'expressageNo', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004440')},
          ]
        }
      ],
      dropDownTimeList: [
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004474'), value: 1, parameterKey: ['createdStartTime', 'createdEndTime']},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004565'), value: 2, parameterKey: ['shipedStartTime', 'shipedEndTime']},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000525'), value: 3, parameterKey: ['estimateArrivalOfGoodsStartTime', 'estimateArrivalOfGoodsEndTime']},
      ],
      defaultSelectTimeValue: 1,
      settlementStatusList: [
        {value: 1, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004596')},
        {value: 2, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004597')},
        {value: 3, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004598')}
      ],
      reviewedTotal: 0,
      customColumnsKey: 'supplierOrdersColumns',
      setColumnsList: [],
      defaultSelectKeyList: ['subPackageCode', 'idx', 'options'],
      timer: null,
      nowTime: Date.now(),
      formatType: 'yyyy-MM-dd HH:mm:ss',
      useLogisticsList: [],
      enumData: []
    };
  },
  computed: {
    filterKeyList() {
      let list = [...this.dropDownInputList_1, ...this.dropDownInputList_2];
      let parameterKeyList = list.map((item) => {
        return item.parameterKey;
      });
      return parameterKeyList;
    },
    // 出库状态
    outPackageStatusEnumList() {
      const ENUM_KEY = 'YmsSubPackageInfoIsOutPackageStatusCoreEnum';
      return getEnumList(this.enumData, ENUM_KEY, 'number');
    },
    // 供应商订单状态
    orderStatusData() {
      const ENUM_KEY = 'YmsSubPackageInfoOrderStatusCoreEnum';
      return getEnumList(this.enumData, ENUM_KEY, 'number');
    },
  },
  created() {
    if (['0', '3', '4'].includes(this.pageParams.orderStatusTab)) {
      this.setDefaultTimerParams('three_months', 1);
    }
    this.initFun();
  },
  methods: {
    // 初始化接口数据
    initFun() {
      (async () => {
        let enumKeyList = [
          'YmsSubPackageInfoIsOutPackageStatusCoreEnum',
          'YmsSubPackageInfoOrderStatusCoreEnum',
          'TransportTypeEnum'
        ];
        this.enumData = await getDataSetBatchList(enumKeyList);
        await this.handleStatusData(this.pageParams.orderStatusTab);
        await this.getUseLogistics();
        await this.search('update');
      })();
    },
    // 重置数据
    reset() {
      let v = this;
      v.$refs['pageParams'].resetFields();
      v.pageParams.timeoutStart = null;
      v.pageParams.timeoutEnd = null;
      v.changeInput(1, '_1');
      v.changeInput(1, '_2');
      v.selectTableData = [];
      v.changeTimeInput(1);
      if (['0', '3', '4'].includes(v.pageParams.orderStatusTab)) {
        v.setDefaultTimerParams('three_months', 1);
      }
      v.getList();
    },
    // 查询按钮
    search(value) {
      this.pageParams.pageNum = 1;
      this.getList(value);
    },
    // 列表查询的方法
    getList(value) {
      let v = this;
      if (!isValueEmpty(v.pageParams.timeoutStart) && !isValueEmpty(v.pageParams.timeoutEnd)) {
        if (v.pageParams.timeoutStart <= v.pageParams.timeoutEnd) {
          handleList();
        } else {
          v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004599'));
          return false;
        }
      } else {
        handleList();
      }

      function handleList() {
        v.selectTableData = [];
        v.total = 0;
        v.tableData = [];
        v.optionBtnWidth = [];
        v.handleColumns();
        if (v.getPermission('ymsSubPackageInfo_querySupplierPackageInfoOrder')) {
          v.tableLoading = true;
          v.axios.post(api.post_ymsSubPackageInfo_querySupplierPackageInfoOrder, v.handleParameter()).then(response => {
            if (response.data.code === 0) {
              let data = response.data.datas;
              let list = data.list || [];
              v.total = data.total;
              if (list.length > 0) {
                v.handleTableData(list);
                if (v.pageParams.orderStatusTab === '1' && value === 'update') {
                  v.reviewedTotal = data.total;
                }
              } else {
                v.tableLoading = false;
              }
            } else {
              v.tableLoading = false;
            }
          });
        } else {
          v.gotoError();
        }
      }
    },
    // 处理列表数据
    handleTableData(data) {
      let v = this;
      let ymsProductGoodsIds = [];
      let newData = [];
      v.$nextTick(() => {
        if (v.pageParams.orderStatusTab === '1') {
          v.startRemainTimer();
        } else {
          v.stopRemainTimer();
        }
      });
      data.map((item) => {
        let newList = item.ymsSubPackageGoods || [];
        // 按照ymsSku升序排列
        let ymsSubPackageGoods = newList.sort((a, b) => a.ymsSku.localeCompare(b.ymsSku)) || [];

        if (ymsSubPackageGoods.length > 0) {
          item['totalOrderPrice'] = ymsSubPackageGoods.reduce((accumulator, talg) => {
            return accumulator + talg.productGoodsCost * talg.quantity;
          }, 0);
          ymsSubPackageGoods.map((ele, index) => {
            ele['length'] = ymsSubPackageGoods.length;
            ele['currentTalg'] = (ymsSubPackageGoods.length > 1 && index === 0);
            ele.subPackageCode = item.subPackageCode;
            ele['totalOrderPrice'] = item.totalOrderPrice;
            ele.expressageNo = item.expressageNo;
            ele.trackingNumber = item.trackingNumber;
            ele.carrierName = item.carrierName;
            newData.push(Object.assign({}, item, ele));
          });
        } else {
          newData.push(item);
        }
      });
      if (newData.length > 0) {
        newData.map((item, index) => {
          item['tableLength'] = newData.length;
          if (item.currentTalg) {
            item['currentIndex'] = index;
          }
          if (item.ymsProductGoodsId) {
            ymsProductGoodsIds.push(item.ymsProductGoodsId);
          }
        });
        if (ymsProductGoodsIds.length > 0) {
          (async () => {
            ymsProductGoodsIds = v.uniqueFunc(ymsProductGoodsIds);
            let handleList = await v.getProductInfoByIds(ymsProductGoodsIds, newData, false, false, false);
            if (handleList.length > 0) {
              v.tableData = handleList;
              v.updateTableDom('tableDom');
            }
          })();
        } else {
          v.tableData = data;
          v.updateTableDom('tableDom');
        }
      }
    },
    // 获取使用过的物流商数据
    getUseLogistics() {
      this.useLogisticsList = [];
      this.axios.get(api.get_expressageHundred_query + '?type=kuaidi100').then(response => {
        if (response.data.code === 0) {
          let typeShippingList = response.data.datas || [];
          if (typeShippingList.length > 0) {
            this.axios.get(api.get_ymsPickupOrder_queryLogistics).then(response => {
              if (response.data.code === 0) {
                let data = response.data.datas || [];
                if (data.length > 0) {
                  data.map((item) => {
                    typeShippingList.map((ele) => {
                      if (item.carrierId === ele.code) {
                        item.carrierName = ele.name;
                      }
                    });
                  });
                  this.useLogisticsList = data;
                  this.useLogisticsList.unshift({carrierId: "ymspickcollec", carrierName: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001582')}`});
                }
              }
            });
          }
        }
      });
    },
    // 获取选中的时间
    selectTime(data) {
      let v = this;
      let time = data.date;
      let timeList = v.defaultTimePeriod(time);
      let current = data.value;
      let timeTalg = v.defaultSelectTimeValue !== 3;
      v.dropDownTimeList.map((item) => {
        if (item.value === current) {
          let startTimeKey = item.parameterKey[0];
          let endTimeKey = item.parameterKey[1];
          v.$nextTick(() => {
            if (timeTalg) {
              v.$refs['dropDownDateTime'].timeList = v.defaultTimePeriod(time, false);
            } else {
              v.$refs['dropDownDateTime'].timeList = time;
            }
          });
          if (timeTalg) {
            v.pageParams[startTimeKey] = v.$uDate.getUniversalTime(new Date(timeList[0]).getTime(), 'fulltime');
            v.pageParams[endTimeKey] = v.$uDate.getUniversalTime(new Date(timeList[1]).getTime(), 'fulltime');
          } else {
            v.pageParams[startTimeKey] = v.$uDate.getDateTime(new Date(timeList[0]).getTime());
            v.pageParams[endTimeKey] = v.$uDate.getDateTime(new Date(timeList[1]).getTime());
          }
          v.$forceUpdate();
        }
      });
    },
    // 改变默认时间筛选下拉选项的值
    changeTimeInput(value) {
      if (value === 3) {
        this.formatType = 'yyyy-MM-dd';
      } else {
        this.formatType = 'yyyy-MM-dd HH:mm:ss';
      }
      this.defaultSelectTimeValue = value;
      this.$refs['dropDownDateTime'].timeList = [];
      this.dropDownTimeList.map((item) => {
        let startTimeKey = item.parameterKey[0];
        let endTimeKey = item.parameterKey[1];
        this.pageParams[startTimeKey] = null;
        this.pageParams[endTimeKey] = null;
      });
    },
    // 重置选中的时间
    resetTime(value) {
      this.dropDownTimeList.map((item) => {
        if (item.value === value) {
          let startTimeKey = item.parameterKey[0];
          let endTimeKey = item.parameterKey[1];
          this.pageParams[startTimeKey] = null;
          this.pageParams[endTimeKey] = null;
        }
      });
    },
    // 获取下拉选项筛选条件的值
    updateInputValue(data) {
      this.pageParams[data.key] = data.value;
    },
    // 改变默认下拉选项的值
    changeInput(value, type) {
      this['defaultSelectValue' + type] = value;
      this.$refs['dropDownFilter' + type].inputValue = '';
      this['dropDownInputList' + type].map((item) => {
        if (Object.keys(this.pageParams).includes(item.parameterKey)) {
          this.pageParams[item.parameterKey] = '';
        }
      });
    },
    // 勾选列表数据
    tableChange(data) {
      this.selectTableData = data;
    },
    // 参数处理
    handleParameter() {
      let v = this;
      let {orderStatusTab, ...obj} = v.pageParams;
      let params = Object.assign({}, obj);
      for (let key in params) {
        if (v.filterKeyList.includes(key)) {
          params[key] = v.sepCommasFn(params[key], [',', '，', '\n']);
        }
      }
      if (orderStatusTab === '0') {
        params.orderStatusTab = null;
      } else {
        params.orderStatusTab = Number(orderStatusTab);
      }
      return params;
    },
    // 选择导出数据类型  1 按选中导出 2 按查询结果导出
    changeExportBtn(value) {
      this.exportType = value;
      if (value === '1') {
        if (this.selectTableData.length <= 0) {
          this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003077'));
          return false;
        }
      } else {
        if (this.tableData.length <= 0) {
          this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003078'));
          return false;
        }
      }
      this.$refs['exportFields'].getExportFieldsSetting();
    },
    // 导出数据
    exportFieldsDataBtn(obj) {
      let v = this;
      let query = v.handleParameter();
      if (v.exportType === '1') {
        query.packageIds = v.selectTableData.map((item) => {
          return item.ymsSubPackageId;
        });
      } else {
        query.packageIds = [];
      }
      v.$refs['exportFields'].saveExportFieldsSetting().then((data) => {
        if (data) {
          v.axios.post(api.post_ymsSubPackageInfo_exportSupplierPackageInfoOrder, query,
            {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(res => {
            if (res.data.code === 0) {
              v.$refs['exportFields'].exportFieldsModal = false;
              let taskNumber = res.data.datas;
              setTimeout(() => {
                pageJump('/yms.html#/exportTask?operateCode=' + taskNumber, '/yms-core-service', '_blank');
              }, 30);
            }
          });
        }
      });
    },
    // 处理列表字段
    handleColumns(data) {
      let v = this;
      v.optionBtnWidth = [];
      // 1:待发货 2:已发货 3:已完成 4:已取消
      let hideKeyColumns = [];
      let obj = {
        '0': ['remainingShippingTime'],
        '1': ['settlementStatus', 'despatchTime', 'ymsOutTime'],
        '2': ['settlementStatus', 'ymsOutTime', 'remainingShippingTime'],
        '3': ['settlementStatus', 'remainingShippingTime'],
        '4': ['remainingShippingTime']
      };
      hideKeyColumns = obj[v.pageParams.orderStatusTab] || [];
      let sortKeyList = data || v.setColumnsList;
      let list = v.handleCustomColumnsSort(sortKeyList, hideKeyColumns, v.originalColumns, v.defaultSelectKeyList);
      if (list.length > 0) {
        v.tableColumns = list;
      } else {
        v.tableColumns = v.originalColumns.filter((item) => {
          return !hideKeyColumns.includes(item.key);
        });
      }
      v.updateTableDom('tableDom');
    },
    // 切换Tab
    changeTab(name) {
      let v = this;
      v.$refs['pageParams'].resetFields();
      v.changeInput(1, '_1');
      v.changeInput(1, '_2');
      v.changeTimeInput(1);
      v.selectTableData = [];
      v.pageParams.orderStatusTab = name;
      if (['0', '3', '4'].includes(v.pageParams.orderStatusTab)) {
        v.setDefaultTimerParams('three_months', 1);
      }
      v.pageParams.pageNum = 1;
      v.pageParamsStatus = true;
    },
    // 获取当前列表设置展示的字段
    customColumnsData(data) {
      this.setColumnsList = data;
      this.handleColumns(data);
    },
    // 合并单元格
    handleSpan({row, column, rowIndex, columnIndex}) {
      let v = this;
      let columnList = [];
      let handleKeyList = ['commodityInfo', 'quantity', 'orderStatus'];
      if (v.tableColumns.length > 0) {
        v.tableColumns.map((item, index) => {
          if (!handleKeyList.includes(item.key)) {
            columnList.push(index);
          }
        });
      }
      if (columnList.includes(columnIndex)) {
        if (row.length > 1) {
          if (rowIndex === row.currentIndex) {
            return [row.length, 1];
          } else {
            for (let i = 0; i <= row.tableLength; i++) {
              if (rowIndex === i) {
                return [0, 0];
              }
            }
          }
        }
      }
    },
    // 标记缺货
    markOutStockBtn(ymsSubPackageId, type) {
      let v = this;
      v.axios.get(api.get_ymsSubPackageInfo + ymsSubPackageId, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000514')}).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          if (data) {
            data.packageCode = data.subPackageCode;
            data.packageInfoOrderGoodsBos = data.subPackageGoods;
            v.$refs['overtimeOrderProcess'].initOvertimeOrderProcessingData('mark', [data], type);
          } else {
            v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004600'));
            return false;
          }
        }
      });
    },
    // 标记到货
    markArrivalBtn(data) {
      let v = this;
      let query = [
        {
          estimateArrivalOfGoodsTime: null,
          markType: 3, // 标记类型 1.补货 2.停售 3.到货
          operationType: 3, // 操作类型 1.标记缺货 2.更新标记 3.标记到货
          outOfStockQuantity: null,
          packageCodes: [data.subPackageCode],
          productGoodsId: data.ymsProductGoodsId
        }
      ];
      v.axios.post(api.post_ymsSubPackageInfo_markOutStock, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
        if (response.data.code === 0) {
          v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000530'));
          v.pageParamsStatus = true;
        }
      });
    },
    // 开始剩余时间倒计时
    startRemainTimer() {
      if (this.timer) return;
      this.timer = setInterval(() => {
        this.nowTime = Date.now();
      }, 1000);
    },
    // 停止剩余时间倒计时
    stopRemainTimer() {
      clearInterval(this.timer);
      this.timer = null;
    },
    // 处理剩余发货时间
    handleTimeOut(timeoutLeftTime, orderStatus) {
      if (timeoutLeftTime) {
        const diff = new Date(timeoutLeftTime).getTime() - this.nowTime;
        if (diff <= 0) {
          if (orderStatus === 6) {
            return aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004601');
          } else {
            return '-';
          }
        } else {
          const s = Math.floor(diff / 1000);
          const h = Math.floor(s / 3600);
          const m = Math.floor((s % 3600) / 60);
          const sec = s % 60;
          return `${h}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001632')}${m}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003473')}${sec}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004578')}`;
        }
      } else {
        return '-';
      }
    },
    // 处理状态数据
    async handleStatusData(value) {
      // 出库状态
      this.deliveryOrderStatusList = [];
      let values = {
        '0': [1, 2, 3, 4, 5, 6, 7, 8],
        '1': [1, 2, 3, 6],
        '2': [4, 8],
        '3': [4, 5],
        '4': [7]
      };
      if (values[value]) {
        this.outPackageStatusEnumList.map((item) => {
          if (values[value].includes(item.value)) {
            this.deliveryOrderStatusList.push(item);
          }
        });
      }
      // 订单状态
      this.orderStatusList = [];
      let orderValues = {
        '0': [1, 2, 3, 4, 5, 6, 7],
        '1': [1, 6, 7, 3]
      };
      if (orderValues[value]) {
        this.orderStatusData.map((item) => {
          if (orderValues[value].includes(item.value)) {
            this.orderStatusList.push(item);
          }
        });
      }
      if (value === '1') {
        this.startRemainTimer();
      } else {
        this.stopRemainTimer();
      }
    }
  },
  destroyed() {
    this.stopRemainTimer();
  },
  watch: {
    pageParamsStatus(value) {
      let v = this;
      if (value) {
        v.getList();
        v.pageParamsStatus = false;
      }
    },
    // 监听tab栏切换
    'pageParams.orderStatusTab': {
      handler(value) {
        this.handleStatusData(value);
      },
      immediate: true,
      deep: true
    }
  },
  components: {
    exportFieldsModal,
    dropDownFilter,
    dropDownDateTime,
    overtimeOrderProcessingModal,
    customColumnsDrawer,
    supplierOrdersLogModal
  }
};
</script>

<style lang="less" scoped>

</style>
